import axios from "axios"

export const checkoutSession = ({ subscription_id, subscription_purchase_id, goToRootOnSuccess, cancelRedirectRoute }) => {
  const currentRouteParams = window.location.search
  const pathWithParams = window.document.location.pathname + currentRouteParams

  const pathUsedForSuccess = goToRootOnSuccess ? "/" : pathWithParams
  const successPath = subscription_purchase_id
    ? pathUsedForSuccess
    : `${pathUsedForSuccess}${pathUsedForSuccess.includes("?") ? "&" : "?"}subscription_success=true`

  const cancelPath = `${cancelRedirectRoute}${currentRouteParams}${currentRouteParams.includes("?") ? "&" : "?"}subscription_cancelled=true`

  return axios.post("/api/v2/stripe_checkout_sessions", {
    subscription_id,
    subscription_purchase_id,
    success_path: successPath,
    cancel_path: cancelPath
  })
}

export const checkoutSessionForProduct = ({ product_id }) => {
  const pathWithParams = window.document.location.pathname + window.location.search

  return axios.post("/api/v2/stripe_checkout_sessions", {
    product_id,
    success_path: `${pathWithParams}${pathWithParams.includes("?") ? "&" : "?"}purchase_success=true`,
    cancel_path: pathWithParams
  })
}

export const cancelSubscription = (id) => axios.post(`/api/v2/web_subscription_purchases/${id}/cancel`)

export const paymentTicket = () => axios.get("/api/v3/payment_ticket")

export const createPaymentTicket = ({ platform, deviceSummary }) =>
  axios.post("/api/v3/payment_ticket", {
    platform,
    device_summary: deviceSummary
  })

export const completePaymentTicket = () => axios.post("/api/v3/payment_ticket/complete")
